import React from 'react';
import { Helmet } from 'react-helmet-async';
import { siteConfig } from '../config';

const SEOHead = ({ 
  title, 
  description, 
  keywords, 
  image, 
  url, 
  type = 'website',
  structuredData = null 
}) => {
  const fullTitle = title ? `${title} - ${siteConfig.siteTitle}` : siteConfig.siteTitle;
  const fullUrl = url ? `${siteConfig.siteUrl}${url}` : siteConfig.siteUrl;
  const defaultImage = `${siteConfig.siteUrl}/images/hero-image.jpg`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description || siteConfig.defaultDescription} />
      <meta name="keywords" content={keywords || siteConfig.defaultKeywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || siteConfig.defaultDescription} />
      <meta property="og:image" content={image || defaultImage} />
      <meta property="og:site_name" content={siteConfig.siteTitle} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || siteConfig.defaultDescription} />
      <meta name="twitter:image" content={image || defaultImage} />
      
      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content={siteConfig.siteTitle} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
      
      {/* Default Structured Data for Vacation Rental */}
      {!structuredData && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "VacationRental",
            "name": siteConfig.siteTitle,
            "description": siteConfig.defaultDescription,
            "url": siteConfig.siteUrl,
            "image": defaultImage,
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "4 Pin Oak Lane (Just off Ridge)",
              "addressLocality": "Underberg",
              "addressRegion": "KwaZulu-Natal",
              "postalCode": "3257",
              "addressCountry": "ZA"
            },
            "telephone": "+27837944711",
            "email": "jnblodge@gmail.com",
            "priceRange": "$$",
            "amenityFeature": [
              {
                "@type": "LocationFeatureSpecification",
                "name": "Wi-Fi",
                "value": true
              },
              {
                "@type": "LocationFeatureSpecification", 
                "name": "Kitchen",
                "value": true
              },
              {
                "@type": "LocationFeatureSpecification",
                "name": "Mountain View",
                "value": true
              }
            ]
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead; 